export default __webpack_public_path__ + "static/media/results-example-3.d54fd7f8.png";